import { usePDF } from '@react-pdf/renderer';
import React, { useEffect, useMemo } from 'react';
import VoucherDocument from '../VoucherDocument/VoucherDocument';
import { TemplateRenderer, useTemplateOrFallback } from 'PDF/TemplateEngine';
import { resolveDocDesign } from 'PDF/TemplateEngine/resolveDocDesign';
import useSignatureUrls from 'hooks/useSignatureUrls';

function Dowload(props) {
  const { voucher, user, config, images } = props;
  const { template, loading } = useTemplateOrFallback('comprobante');

  const { urls: signatureUrls, ready: signaturesReady } = useSignatureUrls({
    specialist_signature: voucher?.specialist_signature,
    recepcionist_signature: voucher?.recepcionist_signature,
  });

  const design = loading ? null : resolveDocDesign(voucher, template);

  // Siempre producimos un documento válido. Mientras las firmas no están
  // resueltas las pasamos como null (PDFSignatureImage no renderiza nada);
  // cuando `signaturesReady` cambia, `usePDF` regenera el PDF con las URLs.
  // Importante: no devolver null acá, porque `usePDF` con document=null se
  // queda trabado en loading y el <a> nunca aparece.
  const document = useMemo(() => {
    const voucherWithSignatures = {
      ...voucher,
      specialist_signature: signaturesReady ? signatureUrls.specialist_signature : null,
      recepcionist_signature: signaturesReady ? signatureUrls.recepcionist_signature : null,
    };
    if (design === 'lowcode') {
      const hallazgos = (voucher?.hallazgos || []).filter((h) => h.mostrar_en_comprobante);
      const data = {
        ...voucherWithSignatures,
        images,
        hallazgos,
        hallazgos_count: hallazgos.length,
      };
      return <TemplateRenderer template={template} data={data} config={config || {}} />;
    }
    return <VoucherDocument voucher={voucherWithSignatures} config={config} images={images} />;
  }, [design, template, voucher, images, config, signaturesReady, signatureUrls]);

  // `usePDF` de @react-pdf/renderer@4 captura el document solo al montar
  // (su useEffect tiene deps []). Para que las firmas resueltas lleguen al
  // PDF hay que llamar updateInstance manualmente cuando cambia el document.
  const [instance, updateInstance] = usePDF({ document });
  useEffect(() => {
    if (document) updateInstance(document);
  }, [document, updateInstance]);

  if (loading || !signaturesReady || instance.loading) return <div>Cargando...</div>;
  if (instance.error) return <div>Algo salió mal: {instance.error}</div>;
  return (
    <a href={instance.url} download={`Comprobante-${voucher.id}.pdf`}>
      Descargar Comprobante N°{voucher.id}
    </a>
  );
}

export default Dowload;
